(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsExport(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsExport(
            RivalIQ.enums
        );
    }

    function enumsExport(exports) {

        /**
         * The type of export.
         * @type {{EMAIL: string, DOWNLOAD: string}}
         */
        exports.exportType = {
            EMAIL: 'email',
            DOWNLOAD: 'download',
            SCHEDULE: 'scheduled'
        };

        /**
         * The format of the export.
         * @type {{PNG: string, PDF: string, PPT: string, CSV: string}}
         */
        exports.exportFormat = {
            PPT: 'ppt',
            PDF: 'pdf',
            PNG: 'png',
            CSV: 'csv'
        };

        exports.exportFormatSortOrder = [
            exports.exportFormat.PPT,
            exports.exportFormat.PDF,
            exports.exportFormat.PNG,
            exports.exportFormat.CSV
        ];

        /*
         * Page orientation
         */
        exports.orientation = {
            PORTRAIT: 'portrait',
            LANDSCAPE: 'landscape'
        };

        /*
         * The possible slide style types
         */
        exports.slideType = {
            INTRO: 'intro',
            SECTIONAL: 'sectional',
            SINGLE: 'single',
            VERSUS_DOUBLE: 'versus_double',
            COLUMN: 'column',
            MULTI_SRC: 'multi_source'
        };
    }
})();
